import React, { FunctionComponent } from 'react';
import { Col, Row } from 'View/Common';
import { OfferBox, ZppOfferBox } from 'View/Component';
import { SinglePaymentOffer, SubscriptionOffer } from 'api/graphql';

interface IProps {
  offers: {
    zpp: SubscriptionOffer | null;
    subscriptions: (SinglePaymentOffer | SubscriptionOffer)[];
  };
}

export const ZppOffers: FunctionComponent<IProps> = ({ offers }) => {
  return (
    <Row>
      <Col xs={{ size: 12, order: 2 }} md={{ size: 6, order: 1 }} className="offer-wrapper">
        {offers.subscriptions
          .slice()
          .sort((a, b) => a.position - b.position)
          .map((offer) => (
            <OfferBox key={offer.uuid} offer={offer as SinglePaymentOffer | SubscriptionOffer} />
          ))}
      </Col>
      <Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 2 }} className="zpp-offer-wrapper">
        <ZppOfferBox offer={offers.zpp as SubscriptionOffer} />
      </Col>
    </Row>
  );
};
